
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.667 5.778a.892.892 0 01-.89-.89c0-.488.4-.888.89-.888H20v5.333c0 .49-.4.89-.889.89a.891.891 0 01-.889-.89V7.031l-8.115 8.116a.885.885 0 11-1.254-1.254l8.116-8.115h-2.302zm-8 12.444h9.777c.49 0 .89-.4.89-.889V12.89c0-.489.4-.889.888-.889.49 0 .89.4.89.889v5.333c0 .978-.8 1.778-1.779 1.778H5.778C4.8 20 4 19.2 4 18.222V6.667c0-.978.791-1.778 1.778-1.778h5.333c.489 0 .889.4.889.889s-.4.889-.889.889H6.667c-.49 0-.89.4-.89.889v9.777c0 .49.4.89.89.89z"}})])
          )
        }
      }
    